var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardVentures(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 160,
    viewBox: "0 0 224 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.9746 58.5805C-1.5688 42.5585 14.6553 16.1994 30.1492 4.2673C36.8433 -0.89919 46.3471 -0.637304 54.6565 1.21056C67.5678 4.07455 79.4908 10.0812 91.5295 15.5012C103.568 20.9212 116.172 25.8781 129.409 26.4082C141.097 26.8796 150.268 22.0303 162.486 14.2043C172.818 7.58596 184.183 4.63813 194.395 10.0141C204.138 15.1366 211.969 26.7945 210.903 42.0578C207.369 92.6272 162.486 102.5 116.192 86.1183C92.1391 77.6066 83.1191 89.1224 58.5646 95.1307C34.0101 101.139 37.518 74.6025 17.9746 58.5805Z",
    fill: "#2575FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3471 36.0151C13.1302 36.0668 4 36.2326 4 36.2326C4 36.2326 14.8526 21.8578 24.3064 27.1835C33.7602 32.5093 44.6202 36.0454 44.6202 36.0454C44.6202 36.0454 35.564 35.9634 24.3471 36.0151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.326 39.4651C156.977 39.4651 161.558 34.8838 161.558 29.2326C161.558 23.5813 156.977 19 151.326 19C145.674 19 141.093 23.5813 141.093 29.2326C141.093 34.8838 145.674 39.4651 151.326 39.4651Z",
    fill: "#FC6681"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.419 124.909C203.419 119.433 198.976 106.438 193.496 106.438C188.016 106.438 183.574 119.433 183.574 124.909C183.574 127.541 184.619 130.064 186.48 131.925C188.341 133.786 190.865 134.831 193.496 134.831C196.128 134.831 198.652 133.786 200.512 131.925C202.373 130.064 203.419 127.541 203.419 124.909H203.419Z",
    fill: "#0F5EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.938 124.909C200.938 119.433 196.496 106.438 191.015 106.438C185.535 106.438 181.093 119.433 181.093 124.909C181.093 127.541 182.138 130.064 183.999 131.925C185.86 133.786 188.384 134.831 191.016 134.831C193.647 134.831 196.171 133.786 198.032 131.925C199.893 130.064 200.938 127.541 200.938 124.909H200.938Z",
    fill: "#2575FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.326 147.5C191.243 147.5 191.165 147.467 191.106 147.409C191.048 147.351 191.016 147.272 191.016 147.19V119.145C191.016 119.063 191.048 118.984 191.106 118.926C191.165 118.868 191.243 118.835 191.326 118.835C191.408 118.835 191.487 118.868 191.545 118.926C191.603 118.984 191.636 119.063 191.636 119.145V147.19C191.636 147.272 191.603 147.351 191.545 147.409C191.487 147.467 191.408 147.5 191.326 147.5Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.326 123.676C191.264 123.676 191.204 123.658 191.153 123.624C191.102 123.59 191.063 123.542 191.039 123.485C191.016 123.428 191.01 123.366 191.022 123.306C191.034 123.246 191.063 123.19 191.106 123.147L195.161 119.092C195.22 119.034 195.299 119.001 195.381 119.001C195.463 119.001 195.542 119.034 195.6 119.092C195.658 119.15 195.691 119.229 195.691 119.311C195.691 119.393 195.658 119.472 195.6 119.53L191.545 123.586C191.516 123.614 191.482 123.637 191.444 123.653C191.407 123.668 191.366 123.676 191.326 123.676Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 32C72 31.4477 72.4477 31 73 31H77C77.5523 31 78 31.4477 78 32V40C78 40.5523 77.5523 41 77 41H73C72.4477 41 72 40.5523 72 40V32Z",
    fill: "#5F5E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.347 63.0151C122.13 63.0668 113 63.2326 113 63.2326C113 63.2326 123.853 48.8578 133.306 54.1835C142.76 59.5093 153.62 63.0454 153.62 63.0454C153.62 63.0454 144.564 62.9634 133.347 63.0151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 32C70 31.4477 70.4477 31 71 31H73C73.5523 31 74 31.4477 74 32V40C74 40.5523 73.5523 41 73 41H71C70.4477 41 70 40.5523 70 40V32Z",
    fill: "#B6BDCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4036 124.909C62.4036 119.433 57.9611 106.438 52.4811 106.438C47.001 106.438 42.5586 119.433 42.5586 124.909C42.5586 127.541 43.604 130.064 45.4648 131.925C47.3257 133.786 49.8495 134.831 52.4811 134.831C55.1127 134.831 57.6365 133.786 59.4973 131.925C61.3582 130.064 62.4036 127.541 62.4036 124.909H62.4036Z",
    fill: "#0F5EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9231 124.909C59.9231 119.433 55.4806 106.438 50.0006 106.438C44.5206 106.438 40.0781 119.433 40.0781 124.909C40.0781 127.541 41.1235 130.064 42.9844 131.925C44.8452 133.786 47.369 134.831 50.0006 134.831C52.6322 134.831 55.156 133.786 57.0169 131.925C58.8777 130.064 59.9231 127.541 59.9231 124.909H59.9231Z",
    fill: "#2575FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3106 147.5C50.2283 147.5 50.1495 147.467 50.0913 147.409C50.0332 147.351 50.0005 147.272 50.0005 147.19V119.145C50.0005 119.063 50.0332 118.984 50.0913 118.926C50.1495 118.868 50.2283 118.835 50.3106 118.835C50.3928 118.835 50.4717 118.868 50.5298 118.926C50.588 118.984 50.6206 119.063 50.6206 119.145V147.19C50.6206 147.272 50.588 147.351 50.5298 147.409C50.4717 147.467 50.3928 147.5 50.3106 147.5Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3105 123.676C50.2492 123.676 50.1892 123.658 50.1383 123.624C50.0873 123.59 50.0476 123.542 50.0241 123.485C50.0006 123.428 49.9945 123.366 50.0064 123.306C50.0184 123.246 50.0479 123.19 50.0913 123.147L54.1464 119.092C54.2045 119.034 54.2834 119.001 54.3656 119.001C54.4478 119.001 54.5267 119.034 54.5848 119.092C54.643 119.15 54.6756 119.229 54.6756 119.311C54.6756 119.393 54.643 119.472 54.5848 119.53L50.5297 123.586C50.501 123.614 50.4668 123.637 50.4292 123.653C50.3916 123.668 50.3512 123.676 50.3105 123.676Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 39,
    width: 31,
    height: 108,
    rx: 3,
    fill: "#5F5E70"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 39,
    width: 31,
    height: 108,
    rx: 3,
    fill: "#CDD4DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 93,
    width: 30,
    height: 54,
    rx: 3,
    fill: "#5F5E70"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 93,
    width: 49,
    height: 54,
    rx: 3,
    fill: "#C4CBD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 84C125 82.3431 126.343 81 128 81H155C156.657 81 158 82.3431 158 84V93H125V84Z",
    fill: "#5F5E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 84C110 82.3431 111.343 81 113 81H140C141.657 81 143 82.3431 143 84V93H110V84Z",
    fill: "#B6BDCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.262 43.5894C157.045 43.6411 147.915 43.8068 147.915 43.8068C147.915 43.8068 158.767 29.432 168.221 34.7577C177.675 40.0835 188.535 43.6196 188.535 43.6196C188.535 43.6196 179.479 43.5377 168.262 43.5894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117 107C116.448 107 116 107.448 116 108V116C116 116.552 116.448 117 117 117H123C123.552 117 124 116.552 124 116V108C124 107.448 123.552 107 123 107H117ZM117 123C116.448 123 116 123.448 116 124V132C116 132.552 116.448 133 117 133H123C123.552 133 124 132.552 124 132V124C124 123.448 123.552 123 123 123H117ZM129 108C129 107.448 129.448 107 130 107H136C136.552 107 137 107.448 137 108V116C137 116.552 136.552 117 136 117H130C129.448 117 129 116.552 129 116V108ZM130 123C129.448 123 129 123.448 129 124V132C129 132.552 129.448 133 130 133H136C136.552 133 137 132.552 137 132V124C137 123.448 136.552 123 136 123H130Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 57C66 56.4477 66.4477 56 67 56H73C73.5523 56 74 56.4477 74 57V65C74 65.5523 73.5523 66 73 66H67C66.4477 66 66 65.5523 66 65V57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 72,
    width: 8,
    height: 10,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 88,
    width: 8,
    height: 10,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 104,
    width: 8,
    height: 10,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 120,
    width: 8,
    height: 10,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 57C77 56.4477 77.4477 56 78 56H84C84.5523 56 85 56.4477 85 57V65C85 65.5523 84.5523 66 84 66H78C77.4477 66 77 65.5523 77 65V57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 72,
    width: 8,
    height: 10,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 88,
    width: 8,
    height: 10,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 104,
    width: 8,
    height: 10,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 120,
    width: 8,
    height: 10,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 147.4C22 147.179 22.1791 147 22.4 147H208.6C208.821 147 209 147.179 209 147.4C209 147.621 208.821 147.8 208.6 147.8H22.4C22.1791 147.8 22 147.621 22 147.4Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVentures);
export default __webpack_public_path__ + "static/media/card_ventures.9c0061c3.svg";
export { ForwardRef as ReactComponent };